// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ComponentHeading-module-heading-gU70g{width:100%;color:var(--des-color-fill-glyph-primary);font-weight:var(--weight-medium);font-size:var(--des-font-text-text-md-size);line-height:var(--des-font-text-text-md-line-height);text-align:center;text-transform:uppercase;margin-block:var(--spacing-2xl) var(--des-dimension-gap-and-padding-general-away-medium)}[dir=rtl] .ComponentHeading-module-heading-gU70g{letter-spacing:normal}.ComponentHeading-module-noTopMargin-qar4t{-webkit-margin-before:0;margin-block-start:0}.ComponentHeading-module-thin-5iLMV{font-weight:var(--weight-light)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"heading": "ComponentHeading-module-heading-gU70g",
	"noTopMargin": "ComponentHeading-module-noTopMargin-qar4t",
	"thin": "ComponentHeading-module-thin-5iLMV"
};
export default ___CSS_LOADER_EXPORT___;
